<div class="header-with-bg">
  <div class="container w-xl-100 p-0">
    <div class="header__action-bar">
      <nav
        class="navbar navbar-expand-xl navbar-light header row flex-column flex-xl-row align-items-start align-items-xl-center">
        <a class="navbar-brand d-flex align-items-center" href="javascript:void(0);">
          <a routerLink="request/list" class="logo_des">
            <!-- <span class="logo-icon"></span> -->
            <img class="img-responsive" src="/assets/theme/resources/images/landing-page/icon-logo.png" alt="EcCargo Freight Matching Marketplace">
            <div class="caption-logo">
              <p>{{'PangJangFreightMarketplace' | translate}}</p>     <!-- <p>PangJang Freight Marketplace</p> -->
              <p>{{'Slogan' | translate}}</p>  <!-- <p>Where carriers match your price</p> -->
            </div>
          </a>
          <button class="btn-create" (click)="goCreateRequest()" *ngIf="user?.role == accountRoles.Shipper"
            title="{{'CreateRequest' | translate}}">
            <span class="plus-icon"></span>
          </button>
          <button class="btn-create" routerLink="user/carrier/create" *ngIf="user?.role == accountRoles.CustomerService"
            title="{{'CreateCarrier' | translate}}">
            <span class="plus-icon"></span>
          </button>
          <button class="btn-create-freight-post" routerLink="freight-post/form/create" *ngIf="user?.role == accountRoles.Carrier && user?.type == carrierType.Pricing"
            title="{{'CreateFreightPost' | translate}}">
            <span class="plus-icon"></span>
          </button>
        </a>
        <!-- <button class="navbar-toggler u-hamburger border-0" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span id="hamburgerTrigger" class="u-hamburger__box">
                        <span class="u-hamburger__innerf bg-white"></span>
                    </span>
                </button> -->
        <div class="h-100 col d-xl-flex flex-xl-row align-items-xl-center d-block-in-mobile">
          <ul class="header__menu navbar-nav mr-auto justify-content-xl-around col mb-sm-4 mb-xl-0">
            <li class="nav-item"
              *ngIf="user?.role == accountRoles.Shipper || user?.role == accountRoles.CustomerService">
              <a routerLink="request/list" [ngClass]="{'active': listActive}">{{ 'ListedRequest' | translate }}</a>
            </li>
            <li class="nav-item" *ngIf="user?.role == accountRoles.Carrier && user?.type != carrierType.Operation">
              <a routerLink="request/list" [ngClass]="{'active': listActive}">{{ 'RequestSearch' | translate }}</a></li>
            <li class="nav-item" *ngIf="(user?.role == accountRoles.Carrier && user?.type != carrierType.Operation) ||
              user?.role == accountRoles.Shipper">
              <div ngbDropdown class="nav-item__dropdown" autoClose="outside" placement="bottom-center" #FreightPostDropdown="ngbDropdown">
                <a class="nav-item__dropdown__label" id="FreightPostDropdown" ngbDropdownToggle  [ngClass]="{'active': freightPostMenuActive}">
                  {{ 'FreightPosts' | translate }}
                  <span class="ei-icon_arrow_triangle-down"></span>
                </a>
                <div ngbDropdownMenu aria-labelledby="FreightPostDropdown" class="nav-item__dropdown__panel">  
                  <span class="up-arrow-center"></span>
                  <ul>
                    <li *ngIf="user?.role == accountRoles.Shipper">
                      <a routerLink="freight-post/search" (click)="FreightPostDropdown.close()" [ngClass]="{'active': freightPostSearchActive}">{{ 'SearchFreightPost' | translate }}</a>
                    </li>
                    <li *ngIf="user?.role == accountRoles.Carrier">
                      <a routerLink="freight-post/list" (click)="FreightPostDropdown.close()" [ngClass]="{'active': freightPostsActive}">{{ 'ListedFreightPosts' | translate }}</a>
                    </li>
                    <li>
                      <a routerLink="request/freight-post" (click)="FreightPostDropdown.close()" [ngClass]="{'active': freightPostRequestListActive}">{{ 'ListedFreightPostRequests' | translate }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="nav-item" *ngIf="user?.role && user?.type != carrierType.BrowsingOnly">
              <a routerLink="request/deal" [ngClass]="{'active': dealActive}">{{ 'DealManagement' | translate }}</a>
            </li>
            <li class="nav-item" *ngIf="user?.role == accountRoles.Shipper">
              <a routerLinkActive="active" routerLink="request/refund">{{ 'RefundRecords' | translate }}</a>
            </li>
            <li class="nav-item" *ngIf="user?.role == accountRoles.Shipper">
              <a routerLinkActive="active" routerLink="request/penalty">{{ 'PenaltyRecords' | translate }}</a>
            </li>
            <li class="nav-item"
              *ngIf="user?.role == accountRoles.Carrier && user?.type != carrierType.Operation && user?.type != carrierType.BrowsingOnly">
              <a routerLinkActive="active"
                routerLink="request/transaction-history">{{ 'TransactionHistory' | translate }}</a>
            </li>
            <li class="nav-item" *ngIf="user?.role == accountRoles.CustomerService">
              <a routerLink="user/shipper/list"
                [ngClass]="{'active': shipperListActive}">{{ 'RegisteredShippers' | translate }}</a>
            </li>
            <li class="nav-item" *ngIf="user?.role == accountRoles.CustomerService">
              <a routerLink="user/carrier/list"
                [ngClass]="{'active': carrierListActive}">{{'RegisteredCarriers' | translate}}</a>
            </li>
            <!-- Undo comment below when start Deliver 2 of Batch 11 -->
            <!-- <li class="nav-item" *ngIf="user?.role == accountRoles.CustomerService">
              <div ngbDropdown class="menu-item-dropdown">
                <a [ngClass]="{'active': isSettlementActive()}" ngbDropdownToggle>{{'Settlements' | translate}}</a>
                <div ngbDropdownMenu>
                  <ul>
                    <li>
                      <a routerLink="settlement/list-deal" [ngClass]="{'sub-item-active': dealsToSettleActive}">{{'Deals to Settle' | translate}}</a>
                    </li>
                    <li class="divider"></li>
                    <li>
                      <a routerLink="settlement/settled-deals" [ngClass]="{'sub-item-active': settledDealsActive}">{{'Settled Deals' | translate}}</a>
                    </li>
                    <li class="divider"></li>
                    <li>
                      <a routerLink="settlement/payment-advices" [ngClass]="{'sub-item-active': paymentAdviceActive}">{{'Payment Advices' | translate}}</a>
                    </li>
                    <li class="divider"></li>
                    <li>
                      <a routerLink="settlement/list" [ngClass]="{'sub-item-active': settlementListActive}">{{'Settlements' | translate}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </li> -->
          </ul>
          <!-- </div> -->
          <!-- </div> -->
          <!-- <div class="custom-width"> -->
          <div class="d-flex justify-content-between flex-wrap d-block-in-mobile">
            <div class="d-flex">
              <div ngbDropdown [placement]="'bottom-left'">
                <button class="btn-lang" id="langDropdown" ngbDropdownToggle>{{selectedLangName}}</button>
                <div ngbDropdownMenu aria-labelledby="langDropdown" class="header__lang-dropdown">
                  <span class="up-arrow-left"></span>
                  <ul>
                    <li>
                      <a *ngFor="let lang of languages" (click)="onLanguageChange(lang.value)">{{ lang.display }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="header__noti" ngbDropdown>
                <button ngbDropdownToggle id="notiDropdown" class="btn-noti" (click)="onBellClick()"></button>
                <div *ngIf="notificationCount > 0" class="header__noti__count">
                  {{notificationCount}}
                </div>
                <div ngbDropdownMenu aria-labelledby="notiDropdown"
                  class="header__noti__list dropdown-menu-left dropdown-menu-lg-right">
                  <ul>
                    <li *ngIf="notifications == null || notifications.length == 0" class="header__noti__list__item">
                      <div class="header__noti__list__item__message text-center">
                        {{'NoWarningItems' | translate}}</div>
                    </li>
                    <li *ngFor="let noti of notifications" class="header__noti__list__item"
                      [ngClass]="noti.read ? '' : 'read'" (click)="onNotificationClick(noti.requestId)">
                      <div class="header__noti__list__item__logo">
                        <img *ngIf="noti.companyLogo" src="noti.companyLogo" alt="company logo">
                        <img *ngIf="!noti.companyLogo" src="assets/theme/resources/images/header/logo-default.png" alt="EcCargo Freight Matching Marketplace">
                      </div>
                      <div class="header__noti__list__item__message">
                        <p>{{ noti.messageKey | translate }}
                          <span>{{ noti.requestNumber }}</span></p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="header__profile">
              <label class="header__profile__name">{{user?.displayName}}</label>
              <div ngbDropdown class="d-inline-block header__profile__dropdown" autoClose="outside"
                placement="bottom-left" #myDrop="ngbDropdown">
                <button class="btn-profile" id="dropdownProfile" ngbDropdownToggle></button>
                <div ngbDropdownMenu aria-labelledby="dropdownProfile"
                  class="dropdown-menu-left dropdown-menu-lg-right">
                  <span class="up-arrow"></span>
                  <ul>
                    <li>
                      <div class="row profile-header align-items-center">
                        <table>
                          <tr>
                            <td>
                              <img class="logo"
                                [src]="companyLogo || 'assets/theme/resources/images/header/logo-default.png'" alt="EcCargo Freight Matching Marketplace">
                            </td>
                            <td>
                              <div class="pl-3">
                                <h5>{{user?.displayName}}</h5>
                                <label *ngIf="user?.jobTitle">{{user?.jobTitle}}</label>
                              </div>

                            </td>
                          </tr>
                        </table>
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li *ngIf="user?.role == accountRoles.Shipper">
                      <a routerLink="user/shipper-profile" (click)="myDrop.close();"><span
                          class="profile-icon"></span>{{'ViewMyProfile' | translate}}</a>
                    </li>
                    <li *ngIf="user?.role == accountRoles.Carrier">
                      <a routerLink="user/carrier-profile" (click)="myDrop.close();"><span
                          class="company-icon"></span>{{'CompanyProfile' | translate}}</a>
                    </li>
                    <li>
                      <a (click)="onClickChangePassword(); myDrop.close();"><span
                          class="lock-icon"></span>{{'ChangePassword' | translate}}</a>
                    </li>
                    <li *ngIf="user?.role == accountRoles.CustomerService">
                      <a (click)="goDashboardHangfire(); myDrop.close();"><span class="icon_cogs"></span>Hangfire
                        Dashboard</a>
                    </li>
                    <li>
                      <a (click)="onClickSignOut(); myDrop.close();"><span
                          class="logout-icon"></span>{{'Logout' | translate}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </nav>
    </div>
  </div>
</div>

<ng-template #contentAlertCreateRequest let-c="close" let-d="dismiss">
  <div class="bg-header"></div>
  <div class="modal-body">
    <div class="row">
      <div class="col text-center pb-3">
        <label>{{ 'MessageAlertCreateRequest-1' | translate }} <a routerLink="/user/shipper-profile"
            (click)="d('Cancel click')">{{ 'MessageAlertCreateRequest-2' | translate }}</a>
          {{ 'MessageAlertCreateRequest-3' | translate }}</label>
      </div>
    </div>

    <div class="wrap-button">
      <button type="button" class="btn btn-danger" (click)="d('Cancel click')">{{'Cancel' | translate}}</button>
    </div>
  </div>
</ng-template>
